import { Teleport, computed, defineComponent, onMounted, watch, onUnmounted } from 'vue';
import classNames from '../_util/classNames';
export default defineComponent({
    name: 'Notice',
    inheritAttrs: false,
    props: [
        'prefixCls',
        'duration',
        'updateMark',
        'noticeKey',
        'closeIcon',
        'closable',
        'props',
        'onClick',
        'onClose',
        'holder',
        'visible',
    ],
    setup(props, { attrs, slots }) {
        let closeTimer;
        let isUnMounted = false;
        const duration = computed(() => (props.duration === undefined ? 4.5 : props.duration));
        const startCloseTimer = () => {
            if (duration.value && !isUnMounted) {
                closeTimer = setTimeout(() => {
                    close();
                }, duration.value * 1000);
            }
        };
        const clearCloseTimer = () => {
            if (closeTimer) {
                clearTimeout(closeTimer);
                closeTimer = null;
            }
        };
        const close = (e) => {
            if (e) {
                e.stopPropagation();
            }
            clearCloseTimer();
            const { onClose, noticeKey } = props;
            if (onClose) {
                onClose(noticeKey);
            }
        };
        const restartCloseTimer = () => {
            clearCloseTimer();
            startCloseTimer();
        };
        onMounted(() => {
            startCloseTimer();
        });
        onUnmounted(() => {
            isUnMounted = true;
            clearCloseTimer();
        });
        watch([duration, () => props.updateMark, () => props.visible], ([preDuration, preUpdateMark, preVisible], [newDuration, newUpdateMark, newVisible]) => {
            if (preDuration !== newDuration ||
                preUpdateMark !== newUpdateMark ||
                (preVisible !== newVisible && newVisible)) {
                restartCloseTimer();
            }
        }, { flush: 'post' });
        return () => {
            var _a, _b;
            const { prefixCls, closable, closeIcon = (_a = slots.closeIcon) === null || _a === void 0 ? void 0 : _a.call(slots), onClick, holder } = props;
            const { class: className, style } = attrs;
            const componentClass = `${prefixCls}-notice`;
            const dataOrAriaAttributeProps = Object.keys(attrs).reduce((acc, key) => {
                if (key.startsWith('data-') || key.startsWith('aria-') || key === 'role') {
                    acc[key] = attrs[key];
                }
                return acc;
            }, {});
            const node = (<div class={classNames(componentClass, className, {
                    [`${componentClass}-closable`]: closable,
                })} style={style} onMouseenter={clearCloseTimer} onMouseleave={startCloseTimer} onClick={onClick} {...dataOrAriaAttributeProps}>
          <div class={`${componentClass}-content`}>{(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)}</div>
          {closable ? (<a tabindex={0} onClick={close} class={`${componentClass}-close`}>
              {closeIcon || <span class={`${componentClass}-close-x`}/>}
            </a>) : null}
        </div>);
            if (holder) {
                return <Teleport to={holder} v-slots={{ default: () => node }}></Teleport>;
            }
            return node;
        };
    },
});
